import React from "react";
import {
  Button,
  Modal,
  Form
} from "antd";
import Select from "react-select";
import {
  Control,
  Controller,
  SubmitHandler,
  UseFormHandleSubmit,
} from "react-hook-form";
// utils

import {
  FirmwareBase,
  LatestFirmwareGlobal
} from "utils/interfaces";
// components

interface EditCannyModalProps {
    showEditModal: boolean,
    toggleEditModal: (makeVisible: boolean) => void,
    loadingButtons: boolean,
    firmwareVersions: FirmwareBase[] | undefined,
    updateCanny: SubmitHandler<LatestFirmwareGlobal>,
    cannyEditSubmit: UseFormHandleSubmit<LatestFirmwareGlobal, LatestFirmwareGlobal>,
    control: Control<LatestFirmwareGlobal, any, LatestFirmwareGlobal>,
    isValid: boolean,
    isDirty: boolean
}

const EditGlobalLatestFirmwareModal: React.FC<EditCannyModalProps> = ({
    showEditModal,
    toggleEditModal,
    loadingButtons,
    updateCanny,
    cannyEditSubmit,
    firmwareVersions,
    control,
    isValid,
    isDirty
}) => {

  return (
    <Modal
      title={`Editing Latest firmware version for automatic updates`}
      open={showEditModal}
      onCancel={() => toggleEditModal(false)}
      closable={!loadingButtons}
      mask={{ closable: !loadingButtons }}
      footer={[
        <Button onClick={() => toggleEditModal(false)} disabled={loadingButtons}>Close</Button>,
        <Button
          onClick={cannyEditSubmit(updateCanny)}
          loading={loadingButtons}
          type="primary"
          disabled={!isValid || !isDirty || loadingButtons}
        >Save Changes</Button>
      ]}
    >
      <Form layout="vertical" preserve={false}>
        <Form.Item label="Select Latest Firmware Version">
          <Controller
            name="firmware_base_id"
            control={control}
            render={({ field }) => (
              <Select
                {...field}
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                menuPosition="fixed"
                menuPlacement="bottom"
                isSearchable
                options={[
                  ...[...(firmwareVersions || [])].reverse(),
                ]}
                getOptionLabel={(option) => option.version_name}
                getOptionValue={(option) => String(option.id)}
                value={
                  (firmwareVersions ?? []).find((fw) => fw.id === field.value)
                }
                onChange={(selectedOption) =>
                  field.onChange(selectedOption ? selectedOption.id : null)
                }
              />
            )}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditGlobalLatestFirmwareModal;
